module.exports = __webpack_public_path__ + "mada-v7-latin-500.woff2";